import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import * as fromRoot from '../../../store/reducers';
import * as messageActions from '../../../store/actions/messages';
import { AppMessages } from '../../../shared/configs/app.messages';
import { getSelected } from '../../../store/reducers/user';
import { AppUser } from '../../../models/user.model';

const fireRefreshEventOnWindow = function () {
  const evt = document.createEvent('HTMLEvents');
  evt.initEvent('resize', true, false);
  window.dispatchEvent(evt);
};


@Component({
  selector: 'app-admin-html-layout',
  templateUrl: './admin-html-layout.component.html',
  styleUrls: ['./admin-html-layout.component.css']
})
export class AdminHtmlLayoutComponent implements OnInit, OnDestroy {

  options = {
    direction: 'ltr'
  };

  // app messages
  messageError: any;
  messageSuccess: any;
  //
  subscribers: Array<any> = [];
  // user
  user: AppUser;

  constructor(private elementRef: ElementRef,
              private store: Store<fromRoot.AppState>,
              private toastr: ToastrService) { }

  ngOnInit() {
    // sidebar toggle event listner
    this.elementRef.nativeElement.querySelector('#sidebarToggle')
      .addEventListener('click', this.onClick.bind(this));
    // customizer events
    /*this.elementRef.nativeElement.querySelector('#cz-compact-menu')
      .addEventListener('click', this.onClick.bind(this));
    this.elementRef.nativeElement.querySelector('#cz-sidebar-width')
      .addEventListener('click', this.onClick.bind(this));*/

    // messages state
    this.subscribers[0] = this.store.pipe(select((state: any) => state.messages))
      .subscribe((messagesState) => {
          this.messageError = messagesState.error;
          this.messageSuccess = messagesState.success;
          //
          if (messagesState.success) {
            this.toastr.success(messagesState.success, AppMessages.APP_TITLE_SUCCESS);
          }
          if (messagesState.error) {
            this.toastr.error(messagesState.error, AppMessages.APP_TITLE_FAIL);
          }
          // clear
          if (messagesState.success || messagesState.error) {
            this.store.dispatch(new messageActions.ClearMessages());
          }
    });

    // user
    this.subscribers[1] = this.store.pipe(select(fromRoot.selectUserState()))
      .subscribe((state: any) => {
        this.user = getSelected(state);
    });

  }

  onClick(event) {
    // initialize window resizer event on sidebar toggle click event
    setTimeout(() => { fireRefreshEventOnWindow(); }, 300);
  }

  getOptions($event): void {
    this.options = $event;
  }

  ngOnDestroy() {
    this.subscribers.forEach( s => s.unsubscribe());
  }

}
